import { DefaultThemeWithFonts, defaultTheme } from '@hqo/react-components-library/dist/molecules/theme';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';

import { configSelector } from 'store/config/selectors';
import { getBuildingTheme } from 'store/theme/actions';
import { hqoTheme } from '@hqo/react-components-library/dist/hqo-theme-provider';
import { selectBrandTheme } from 'store/theme/selectors';

export const useBuildingTheme = (): DefaultThemeWithFonts => {
  const dispatch = useDispatch();
  const brandTheme = useSelector(selectBrandTheme);

  const { buildingUuid } = useSelector(configSelector);

  useEffect(() => {
    if (buildingUuid) {
      dispatch(getBuildingTheme.request(buildingUuid as string));
    }
  }, [dispatch, getBuildingTheme, buildingUuid]);

  return useMemo(() => {
    if (brandTheme) {
      return {
        colors: {
          ...defaultTheme.colors,
          $primary: brandTheme.primary_color,
          $secondary: brandTheme.secondary_color,
          primary: brandTheme.primary_color,
          secondary: brandTheme.secondary_color,
          fontColor: brandTheme.primary_font_color ?? hqoTheme.colors.greys.adminBlack,
        },
        fonts: brandTheme.font?.body?.font_family ? [`${brandTheme.font?.body?.font_family}`, ...hqoTheme.fonts] : null,
      };
    }
    return defaultTheme;
  }, [brandTheme, defaultTheme, buildingUuid]);
};
